import { render, staticRenderFns } from "./BuyOcPlusIntro.vue?vue&type=template&id=13ebf7a6"
import script from "./BuyOcPlusIntro.vue?vue&type=script&lang=js"
export * from "./BuyOcPlusIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseButton: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/28072026_073241/resources/assets/marketplace/components/BaseButton.vue').default})
